{
  "hcp_badge": "HCP",
  "new_round": "Uusi kierros",
  "record_round_title": "Kirjaa kierros",
  "record_round_subtitle": "Täytä tiedot ja siirry tuloskorttiin syöttämään tulokset.",
  "creating_round": "Luodaan kierrosta...",
  "golf_round": "Kierros",
  "score": "Tulos",
  "holes": "reikää",
  "holes_played": "reikää pelattu",
  "active_status": "Aktiivinen",
  "completed_status": "Valmis",
  "abandoned_status": "Keskeytetty",
  "failed_to_load_rounds": "Kierrosten lataaminen epäonnistui",
  "failed_to_create_new_round": "Uuden kierroksen luominen epäonnistui",
  "failed_to_load_active_round": "Aktiivisen kierroksen lataaminen epäonnistui",
  "round": "Kierros",
  "new_round_started": "Uusi kierros aloitettu!",
  "round_started_with_competitions": "Uusi kierros aloitettu viikkokilpailuun!",
  "failed_to_create_round": "Uuden kierroksen luominen epäonnistui",
  "round_completed": "Kierros valmis!",
  "round_completed_and_submitted_to_competitions": "Kierros valmis ja lähetetty {{count}} viikkokilpailuun!",
  "round_completed_but_submission_failed": "Kierros valmis, mutta lähetys viikkokilpailuihin epäonnistui",
  "failed_to_complete_round": "Kierroksen päättäminen epäonnistui",
  "are_you_sure_abandon_round": "Haluatko varmasti keskeyttää tämän kierroksen?",
  "round_abandoned": "Kierros keskeytetty",
  "failed_to_abandon_round": "Kierroksen keskeyttäminen epäonnistui",
  "abandon": "Hylkää",
  "abandon_round": "Hylkää",
  "delete_round": "Poista kierros",
  "delete_round_confirm_title": "Poista kierros",
  "delete_round_confirm_message": "Haluatko varmasti poistaa kierroksen '{{roundName}}'? Tätä toimintoa ei voi peruuttaa.",
  "round_deleted_successfully": "Kierros poistettu onnistuneesti",
  "failed_to_delete_round": "Kierroksen poistaminen epäonnistui",
  "delete_not_supported_yet": "Poisto-toiminto ei ole vielä käytettävissä palvelimella",
  "complete": "Päätä",
  "complete_round": "Päätä",
  "are_you_sure_complete_round": "Haluatko varmasti päättää tämän kierroksen?",
  "pause": "Keskeytä",
  "pause_round": "Keskeytä",
  "are_you_sure_pause_round": "Haluatko varmasti keskeyttää tämän kierroksen? Voit jatkaa sitä myöhemmin.",
  "round_paused": "Kierros keskeytetty onnistuneesti!",
  "failed_to_pause_round": "Kierroksen keskeyttäminen epäonnistui",
  "round_management": "Kierroksen hallinta",
  "round_actions": {
    "title": "Haluatko lopettaa kierroksen?",
    "complete": "Päätä kierros",
    "pause": "Tallenna ja jatka myöhemmin",
    "delete": "Poista kierros",
    "close": "Sulje"
  },
  "round_finalize": {
    "save_round": "Tallenna kierros",
    "back_to_scoring": "Palaa tulosten syöttöön",
    "handicap_update_failed": "Virhe tallennettaessa tasoituskierrosta",
    "marker_required_warning": "Anna merkitsijän nimi viedäksesi kierroksen eBirdieen"
  },
  "hole": "Reikä",
  "hole_scores": "Reikätulokset",
  "failed_to_update_score": "Tuloksen päivittäminen epäonnistui",
  "failed_to_mark_picked_up": "Nostetuksi merkitseminen epäonnistui",
  "picked_up": "Nostettu",
  "failed_to_clear_score": "Tuloksen tyhjentäminen epäonnistui",
  "scorecard": "Tuloskortti",
  "desktop_scorecard": {
    "score": "Tulos",
    "net": "Net",
    "points": "Pisteet",
    "total": "Yhteensä"
  },
  "current_hole": "Nykyinen reikä",
  "quick_hole_nav": "Siirry reiälle",
  "starting_hole": "Aloitusreikä",
  "starting_hole_help": "Valitse reikä, jolta aloitat kierroksen",
  "hole_status": {
    "completed": "Pelattu",
    "current": "Nykyinen",
    "not_played": "Ei pelattu",
    "picked_up": "Nostettu"
  },
  "out": "Out",
  "in": "In",
  "tot": "Tot",
  "par": "Par",
  "cr": "CR",
  "slope": "Slope",
  "tee": "Tii",
  "front_nine": "Reiät 1-9",
  "back_nine": "Reiät 10-18",
  "total": "Yhteensä",
  "net_total": "Nettotulos",
  "tee_selection": "Tii",
  "handicap_index": "Tarkka tasoitus",
  "handicap": "Tasoitus",
  "handicap_abbr": "HCP",
  "handicap_factor": "Tasoituskerroin",
  "playing_handicap": "Pelitasoitus",
  "course": "Kenttä",
  "start_round": "Aloita kierros",
  "continue_to_scorecard": "Jatka tuloskorttiin",
  "start_round_pay_required": "Siirry maksamaan",
  "start_round_pay_voluntary": "Jatka",
  "start_round_v2": "Aloita kierros (V2)",
  "select_course_and_tee": "Valitse kenttä ja tii",
  "course_and_tee": "Kenttä ja tii",
  "search_courses": "Hae kenttiä...",
  "select_course": "Valitse kenttä",
  "nearest_courses": "Lähimmät kentät",
  "all_courses": "Kaikki kentät",
  "recent_courses": "Viimeisimmät kentät",
  "no_courses_found": "Kenttiä ei löytynyt",
  "no_courses_available": "Ei kenttiä saatavilla",
  "played_date": "Kierroksen ajankohta",
  "played_date_edit_title": "Kierroksen ajankohta",
  "played_date_updated_successfully": "Kierroksen ajankohta päivitetty",
  "played_date_update_failed": "Kierroksen ajankohdan päivitys epäonnistui",
  "private_round": "Yksityinen kierros",
  "private_round_description": "Kierros ei näy ystävillesi",
  "private": "Yksityinen",
  "select_tee_set": "Valitse tii",
  "failed_to_load_courses": "Kenttien lataus epäonnistui",
  "failed_to_load_course_details": "Kentän tietojen lataus epäonnistui",
  "scorecard_view": {
    "scorecard_not_found": "Tuloskorttia ei löydy",
    "scorecard_not_found_subtitle": "Pyydettyä tuloskorttia ei voitu ladata",
    "scorecard_not_found_message": "Tämä tuloskortti on saatettu poistaa tai sinulla ei ole oikeutta katsella sitä.",
    "back_to_dashboard": "Takaisin etusivulle",
    "back": "Takaisin",
    "date_played": "Pelipäivä",
    "notes": "Muistiinpanot",
    "length": "Pituus",
    "hcp": "HCP",
    "score": "Tulos",
    "par": "Par",
    "hole": "Reikä",
    "pituus": "Pituus",
    "golf_course": "Golfkenttä",
    "no_scorecard_data": "Tuloskortin tiedot eivät ole saatavilla",
    "failed_to_load_scorecard": "Tuloskortin lataus epäonnistui",
    "strokes": "Lyönnit",
    "hole_disabled": "Reikä ei ole käytössä tällä kierroksella",
    "share": "Jaa",
    "share_preview_title": "Jaa tuloskortti",
    "share_recommended": "Suositeltu jakotapa",
    "share_variant_feed": "Instagram- ja Facebook-syöte",
    "share_variant_story": "Instagram-tarina",
    "share_title": "Golf-kierrokseni",
    "share_text": "{{course}} — {{score}} ({{date}})",
    "share_failed": "Kuvan jakaminen epäonnistui",
    "delete_round": {
      "section_title": "Poista kierros",
      "button_label": "Poista kierros",
      "modal_title": "Poista kierros",
      "modal_body": "Haluatko varmasti poistaa tämän kierroksen? Kierros poistetaan pysyvästi tilastoistasi ja poistoa ei voida peruuttaa.",
      "modal_confirm": "Poista kierros",
      "modal_cancel": "Peruuta"
    }
  },
  "conditions": {
    "optional_conditions": "Olosuhteet",
    "add_conditions": "Lisää olosuhteet",
    "updated_successfully": "Olosuhteet päivitetty onnistuneesti",
    "update_failed": "Olosuhteiden päivittäminen epäonnistui",
    "weather": "Sää",
    "weather_sunny": "Aurinkoinen",
    "weather_cloudy": "Pilvinen",
    "weather_light_rain": "Kevyt sade",
    "weather_heavy_rain": "Rankkasade",
    "weather_light_wind": "Kevyt tuuli",
    "weather_strong_wind": "Voimakas tuuli",
    "pin_placement": "Lipun sijoitus",
    "pin_easy": "Helppo",
    "pin_average": "Keskiverto",
    "pin_hard": "Vaikea",
    "green_pace": "Greenin nopeus",
    "pace_slow": "Hidas",
    "pace_average": "Keskiverto",
    "pace_fast": "Nopea",
    "green_hardness": "Greenin kovuus",
    "hardness_soft": "Pehmeä",
    "hardness_average": "Keskiverto",
    "hardness_hard": "Kova",
    "comment": "Lisätiedot",
    "comment_placeholder": "Kirjoita kommentti",
    "no_comment": "Ei lisätietoja",
    "set_conditions": "Aseta",
    "temperature": "Lämpötila",
    "wind_speed": "Tuulen nopeus"
  },
  "round_result_confirmation": {
    "title": "Vahvista kierroksen tulos",
    "round_information": "Kierroksen tiedot",
    "player_name": "Pelaaja",
    "exact_handicap": "Tasoitus",
    "course_name": "Kenttä",
    "tee_name": "Tii",
    "course_rating": "CR-luku",
    "slope_rating": "Slope",
    "playing_handicap": "Pelitasoitus",
    "scorecard": "Tuloskortti",
    "gross_total": "Lyönnit yhteensä (gross)",
    "net_total": "Nettotulos",
    "confirmation_message": "Tarkista tiedot ja vahvista kierroksen tulos. Vahvistamisen jälkeen voit syöttää kierrosolosuhteet.",
    "accept": "Vahvista tulos"
  },
  "statistics": {
    "title": "Tilastot",
    "track_stats": "Tilastointi käytössä",
    "track_stats_description": "Tallenna lyöntitilastot tälle kierrokselle",
    "hole_statistics": "Reiän tilastot",
    "save": "Tallenna",
    "tee_shot": "Avauslyönti",
    "fairway": "Väyläosuma",
    "fairway_center": "Keskellä",
    "fairway_right": "Oikealla",
    "fairway_left": "Vasemmalla",
    "fairway_short": "Lyhyt",
    "fairway_long": "Pitkä",
    "approach": "Lähestyminen",
    "green": "Griiniosuma",
    "green_hit": "Osui",
    "green_right": "Oikealla",
    "green_left": "Vasemmalla",
    "green_short": "Lyhyt",
    "green_long": "Pitkä",
    "short_game": "Lähipeli",
    "putts": "Putit",
    "chips": "Chipit",
    "bunker_shots": "Bunkkerilyönnit",
    "penalties": "Rangaistuslyönnit",
    "putting": "Putti",
    "first_putt_length": "Ensimmäinen putti",
    "sunk_putt_length": "Upotettu putti",
    "meters": "metriä",
    "first_putt_not_set": "Ei asetettu",
    "first_putt_under_3m": "Alle 3 metriä",
    "first_putt_3_5m": "3-5 metriä",
    "first_putt_5_10m": "5-10 metriä",
    "first_putt_10_20m": "10-20 metriä",
    "first_putt_over_20m": "Yli 20 metriä",
    "saves": "Pelastukset",
    "up_and_down": "Up & Down",
    "sand_save": "Sand save",
    "fairway_hits": "Väyläosumat",
    "green_hits": "Griiniosumat",
    "avg_putts": "Putit ka.",
    "avg_putt_distance": "Upotusetäisyys ka. (m)",
    "round_stats": "Kierrostilastot",
    "fir": "FIR",
    "gir": "GIR",
    "ppg": "PPG",
    "fairways_caption": "Väylät",
    "greens_caption": "Greenit",
    "putts_per_hole": "Puttia per reikä",
    "first_putt_avg": "1 putti ka. (m)",
    "no_data": "Ei tilastoja",
    "stats_saved": "Tilastot tallennettu",
    "stats_deleted": "Tilastot poistettu",
    "failed_to_save_stats": "Tilastojen tallennus epäonnistui",
    "failed_to_delete_stats": "Tilastojen poisto epäonnistui",
    "clear_stats": "Tyhjennä",
    "par3_no_fairway": "Fairway-tilastoa ei kerätä par 3 -reille",
    "par3_no_green": "Green-tilastoa ei kerätä par 3 -reille",
    "stats_reminder_title": "Tilastot puuttuvat",
    "stats_reminder_message": "Et ole tallentanut tilastoja tälle reiälle. Haluatko lisätä ne nyt?",
    "add_stats": "Lisää tilastot",
    "skip_stats": "Ohita"
  },
  "handicap_round": {
    "toggle": "Tasoituskierros",
    "marker_label": "Merkitsijä",
    "marker_name": "Merkkarin nimi",
    "info": "Tulos ilmoitetaan eBirdieen tasoituskierroksena",
    "info_competition": "Tulos ilmoitetaan eBirdieen kilpailukierroksena",
    "marker_required": "Merkitsijän nimi vaaditaan tuloksen lähettämiseksi eBirdieen"
  },
  "multiplayer": {
    "players_title": "Pelaajat",
    "add_players": "Lisää pelaajia",
    "add_players_description": "Pidä tuloskorttia koko ryhmälle",
    "tab_ebirdie": "eBirdie",
    "tab_friends": "Kaverit",
    "tab_manual": "Muu",
    "search_title": "Hae eBirdiestä",
    "search_placeholder": "Nimi tai jäsennumero",
    "search_club": "Seura",
    "search_button": "Hae pelaaja",
    "search_results_title": "Hakutulokset",
    "search_no_results": "Ei hakutuloksia",
    "add": "Lisää",
    "manual_title": "Lisää manuaalisesti",
    "first_name": "Etunimi",
    "last_name": "Sukunimi",
    "handicap": "Tasoitus",
    "gender": "Sukupuoli",
    "add_player": "Lisää pelaaja",
    "settings_title": "Pelaajan asetukset",
    "name": "Nimi",
    "tee": "Tii",
    "save": "Tallenna",
    "remove_player": "Poista pelaaja",
    "close": "Sulje",
    "next": "Seuraava",
    "create_round": "Luo kierros",
    "group_created": "Kierrosryhmä luotu",
    "max_players": "Voit lisätä enintään kolme pelaajaa",
    "already_added": "Pelaaja on jo lisätty",
    "scr": "SCR",
    "result": "Tulos",
    "host_scores_hint": "Vain kierroksen isäntä voi kirjata tuloksia",
    "group_section_title": "Ryhmäkierros",
    "abandon_confirm_title": "Keskeytä ryhmäkierros?",
    "abandon_confirm_body": "Kierros päättyy kaikilta ryhmän pelaajilta eikä sitä voi jatkaa. Tätä ei voi perua.",
    "game": {
      "step_title": "Pelimuoto",
      "format": {
        "skins": "Skinit",
        "stroke_play_abbr": "LP",
        "stableford_abbr": "PB",
        "max_score_abbr": "MAX",
        "best_ball_abbr": "BB",
        "skins_abbr": "S"
      },
      "select": "Valitse",
      "selected": "Valittu",
      "coming_soon": "Tulossa",
      "coefficient_label": "Tasoituskerroin",
      "handicap_percent": {
        "scratch": "Scratch",
        "twenty_five": "25 %",
        "fifty": "50 %",
        "seventy_five": "75 %",
        "hundred": "100 %"
      },
      "change_action": "Muokkaa peliasetuksia",
      "change_title": "Vaihda peli",
      "save": "Tallenna",
      "cancel": "Peruuta",
      "change_failed": "Pelin vaihtaminen epäonnistui",
      "best_ball_requires_four": "Vaatii 4 pelaajaa"
    },
    "teams": {
      "own_team": "Oma joukkue",
      "choose_partner": "Valitse joukkuekaveri",
      "add_partner": "Valitse pariksi",
      "remove_partner": "Poista pari",
      "team1": "Joukkue 1",
      "team2": "Joukkue 2"
    },
    "leaderboard": {
      "thru": "PEL",
      "gross": "TOT",
      "to_par": "PAR",
      "points": "PIST",
      "net": "NET",
      "failed_to_load": "Tulostaulun lataaminen epäonnistui",
      "team": "Joukkue {{number}}"
    }
  },
  "distance_unit": "Pituuksien yksikkö",
  "distance_unit_help": "Valitse millä yksiköllä syötät väyläpituudet",
  "unit_suffix": {
    "metric": "m",
    "imperial": "y"
  },
  "units": {
    "meters": "Metrit",
    "yards": "Jaardit"
  }
}